import type { CharSpan } from "@capture/shared";

/**
 * Handwriting Phase 3 — render text with a set of character spans marked.
 * Span-based BY DESIGN (design §4 forward note): today the spans come from
 * `alignCandidates` (engine disagreement); OCR's filed per-char-confidence
 * backlog item will feed the SAME renderer with confidence-derived spans.
 * Spans index CODE POINTS (Array.from segmentation — matching alignCandidates).
 */
export function HighlightedText({ text, spans }: { text: string; spans: CharSpan[] }) {
  if (spans.length === 0) return <span>{text}</span>;
  const chars = Array.from(text);

  const nodes: React.ReactNode[] = [];
  let cursor = 0;
  for (const [i, span] of spans.entries()) {
    if (span.start > cursor) {
      nodes.push(<span key={`t${i}`}>{chars.slice(cursor, span.start).join("")}</span>);
    }
    nodes.push(<mark key={`m${i}`}>{chars.slice(span.start, span.end).join("")}</mark>);
    cursor = span.end;
  }
  if (cursor < chars.length) {
    nodes.push(<span key="tail">{chars.slice(cursor).join("")}</span>);
  }
  return <>{nodes}</>;
}
